export interface DashboardLayoutItem {i:string;x:number;y:number;w:number;h:number;minW?:number;minH?:number;}
/** Insert a row at the visible section without colliding with spanning neighbours. */
export function insertDashboardWidget(layout: DashboardLayoutItem[], item: DashboardLayoutItem, anchorId?:string) {
  if(layout.some(existing=>existing.i===item.i))return layout;
  let y=layout.find(existing=>existing.i===anchorId)?.y ?? layout.reduce((max,existing)=>Math.max(max,existing.y+existing.h),0);
  while(layout.some(existing=>existing.y<y&&existing.y+existing.h>y)) {
    y=Math.min(...layout.filter(existing=>existing.y<y&&existing.y+existing.h>y).map(existing=>existing.y));
  }
  return [...layout.map(existing=>existing.y>=y?{...existing,y:existing.y+item.h}:existing),{...item,x:0,y}];
}
/** Push only collisions down; intentional spaces above or beside a card remain. */
export function resolveDashboardCollisions<T extends DashboardLayoutItem>(layout: readonly T[]): T[] {
  const result=layout.map(item=>({...item}));
  const placed:T[]=[];
  for(const item of [...result].sort((a,b)=>a.y-b.y||a.x-b.x)){
    let collisions:T[];
    do {
      collisions=placed.filter(other=>item.x<other.x+other.w&&item.x+item.w>other.x&&item.y<other.y+other.h&&item.y+item.h>other.y);
      if(collisions.length)item.y=Math.max(...collisions.map(other=>other.y+other.h));
    }while(collisions.length);
    placed.push(item);
  }
  return result;
}
